import DetalhesEdi from "./detalhesEdi";
import {connect} from "react-redux";

export default connect()(DetalhesEdi)
